import { render, staticRenderFns } from "./ArchivesCard.vue?vue&type=template&id=41e3322c&scoped=true&"
import script from "./ArchivesCard.vue?vue&type=script&lang=js&"
export * from "./ArchivesCard.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesCard.vue?vue&type=style&index=0&id=41e3322c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e3322c",
  null
  
)

export default component.exports